var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_59be40f2"]},_vm.$listeners),[_c('cube-button',{attrs:{"inline":"","outline":""}},[_vm._v("inline - outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }